import React, { useEffect, useState, useRef } from "react";
import ApiService from "../../../Services/user/service";

function OptionChain1() {
  const [selectedExpiry, setSelectedExpiry] = useState("");
  const [loading, setLoading] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [symbolSearch, setSymbolSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [expiryListInr, setExpiryListInr] = useState([]);
  const [listDataInr, setListDataInr] = useState([]);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [isLiveUpdating, setIsLiveUpdating] = useState(false);
  const [orderDetails, setOrderDetails] = useState({
    symbol: "",
    price: 0,
    type: "buy",
    optionType: "",
    strike: 0,
    selectedOption: "Market",
    lot: 1,
    qty: 1,
    lotsize: 1,
  });
  const [orderLoading, setOrderLoading] = useState(false);

  const userid = localStorage.getItem("user_id");
  const dropdownRef = useRef(null);
  const priceUpdateIntervalRef = useRef(null);
  const currentTokensRef = useRef([]);

  // CLOSE DROPDOWN ON OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSearchResults([]);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // FETCH LIVE PRICES FROM DATABASE
  const fetchLivePrices = async (tokens) => {
    if (!tokens || tokens.length === 0) return;

    try {
      console.log("🔄 Fetching prices for", tokens.length, "tokens");
      
      // API call to get live prices from database
      const res = await ApiService.getLivePrices({ tokens });

      console.log("📦 API Response:", res.data);

      if (res.data.status && res.data.data) {
        const priceMap = {};
        
        // Create price map from response
        res.data.data.forEach(item => {
          if (item.token && item.lp) {
            // Store both string and number formats for flexibility
            const token = String(item.token);
            const price = parseFloat(item.lp);
            
            priceMap[token] = price;
            console.log(`💰 Token ${token} → ₹${price}`);
          }
        });

        console.log("📊 Price Map:", priceMap);
        console.log("🔢 Total prices fetched:", Object.keys(priceMap).length);

        // Update prices in list - CONVERT TOKENS TO PRICES
        setListDataInr(prev => {
          const updated = prev.map(item => {
            // Convert tokens to string for matching
            const callToken = String(item.call_token);
            const putToken = String(item.put_token);
            
            // Get prices from priceMap using tokens
            const callPrice = priceMap[callToken] || item.call_price || 0;
            const putPrice = priceMap[putToken] || item.put_price || 0;

            if (priceMap[callToken]) {
              console.log(`✅ Call ${callToken} updated: ₹${callPrice}`);
            }
            if (priceMap[putToken]) {
              console.log(`✅ Put ${putToken} updated: ₹${putPrice}`);
            }

            return {
              ...item,
              call_price: callPrice,
              put_price: putPrice
            };
          });

          setLastUpdate(new Date().toLocaleTimeString());
          return updated;
        });
      } else {
        console.warn("⚠️ API returned no data or status false");
      }
    } catch (err) {
      console.error("❌ Error fetching live prices:", err);
      console.error("Error details:", err.response?.data || err.message);
    }
  };

  // START LIVE PRICE UPDATES (Polling every 1 second)
  useEffect(() => {
    if (listDataInr.length > 0 && currentTokensRef.current.length > 0) {
      setIsLiveUpdating(true);

      // Initial fetch
      fetchLivePrices(currentTokensRef.current);

      // Setup polling interval (1 second)
      priceUpdateIntervalRef.current = setInterval(() => {
        fetchLivePrices(currentTokensRef.current);
      }, 1000);

      return () => {
        if (priceUpdateIntervalRef.current) {
          clearInterval(priceUpdateIntervalRef.current);
          priceUpdateIntervalRef.current = null;
        }
        setIsLiveUpdating(false);
      };
    }
  }, [listDataInr.length]);

  // INR SYMBOL SEARCH
  const handleSymbolSearch = async (value) => {
    if (!value || value.length < 2) {
      setSearchResults([]);
      return;
    }

    try {
      setSearchLoading(true);

      const res = await ApiService.optionSymbolSearch({
        symbol: value,
      });

      if (res.data.status) {
        setSearchResults(res.data.data);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      console.error("INR Symbol Search Error:", err);
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  };

  // GET INR EXPIRY LIST
  const handleExpirySelectInr = async (symbol) => {
    try {
      const res = await ApiService.optionSymbolExpiry({
        symbol: symbol,
      });

      if (res.data.status) {
        const list = res.data.data;
        setExpiryListInr(list);

        if (list.length > 0) {
          const firstExpiry = list[0].expiry;
          setSelectedExpiry(firstExpiry);
          handleshowalldatainr(symbol, firstExpiry);
        }
      } else {
        setExpiryListInr([]);
        setSelectedExpiry("");
        setListDataInr([]);
      }
    } catch (err) {
      console.error("INR Symbol Expiry Error:", err);
      setExpiryListInr([]);
    }
  };

  // FETCH INR OPTION CHAIN DATA
  const handleshowalldatainr = async (symbol, expiry) => {
    try {
      setLoading(true);

      // Clear previous interval
      if (priceUpdateIntervalRef.current) {
        clearInterval(priceUpdateIntervalRef.current);
        priceUpdateIntervalRef.current = null;
      }

      const data = {
        userid: userid,
        symbol: symbol,
        expiry: expiry,
      };

      const res = await ApiService.optionRoundToken(data);

      if (res.data.status) {
        const inrData = res.data.data;

        // Extract all tokens (both call and put)
        const tokens = [];
        inrData.forEach((item) => {
          if (item.call_token) tokens.push(item.call_token);
          if (item.put_token) tokens.push(item.put_token);
        });

        currentTokensRef.current = tokens;

        // Set initial data with 0 prices (will be updated by fetchLivePrices)
        setListDataInr(inrData.map(item => ({
          ...item,
          call_price: 0,
          put_price: 0
        })));

        // Fetch initial prices immediately
        if (tokens.length > 0) {
          await fetchLivePrices(tokens);
        }
      } else {
        setListDataInr([]);
        currentTokensRef.current = [];
      }
    } catch (err) {
      console.error("INR Symbol Data Error:", err);
      setListDataInr([]);
      currentTokensRef.current = [];
    } finally {
      setLoading(false);
    }
  };

  // OPEN ORDER MODAL
  const openOrderModal = (symbol, price, type, optionType, strike, lotsize) => {
    setOrderDetails({
      symbol,
      price: Number(price) || 0,
      type,
      optionType,
      strike,
      selectedOption: "Market",
      lot: 1,
      qty: 1,
      lotsize: Number(lotsize) || 1,
    });
    setShowOrderModal(true);
  };

  // PLACE ORDER
  const handlePlaceOrder = async () => {
    setOrderLoading(true);

    try {
      const userid = localStorage.getItem("user_id");

      if (!userid) {
        alert("User not logged in!");
        setOrderLoading(false);
        return;
      }

      const requiredFund = orderDetails.price * orderDetails.qty * orderDetails.lot;

      const orderPayload = {
        userid,
        symbol: orderDetails.symbol,
        price:
          orderDetails.selectedOption === "Market"
            ? orderDetails.price
            : orderDetails.limitStopPrice || orderDetails.price,
        lot: orderDetails.lot,
        qty: orderDetails.qty,
        requiredFund: parseFloat(requiredFund.toFixed(2)),
        type: orderDetails.type.toLowerCase(),
        lotsize: orderDetails.lotsize,
        With_Margin: false,
        selectedOption: orderDetails.selectedOption,
        token: orderDetails.symbol,
        margin_type: "normal",
        app_version: "1.0.19",
      };

      const response = await ApiService.placeOrder(orderPayload);

      if (response.data.status) {
        alert(`✅ Order Placed Successfully!\nOrder ID: ${response.data.order._id}`);
        setShowOrderModal(false);

        setOrderDetails({
          symbol: "",
          price: 0,
          type: "buy",
          optionType: "",
          strike: 0,
          selectedOption: "Market",
          lot: 1,
          qty: 1,
          lotsize: 1,
        });
      } else {
        alert(`❌ Order Failed: ${response.data.message}`);
      }
    } catch (error) {
      console.error("❌ Order Error:", error);
      alert(`Error: ${error.response?.data?.message || error.message}`);
    } finally {
      setOrderLoading(false);
    }
  };

  return (
    <div className="container py-4">
      {/* CONNECTION & UPDATE STATUS */}
      <div className="row mb-3">
        <div className="col-md-6">
          <div
            className={`alert ${
              isLiveUpdating ? "alert-success" : "alert-secondary"
            } mb-0 py-2`}
          >
            <small className="mb-0">
              {isLiveUpdating ? "🟢 Live Updates Active" : "⚪ No Active Updates"}
            </small>
          </div>
        </div>
        <div className="col-md-6">
          {lastUpdate && (
            <div className="alert alert-info mb-0 py-2">
              <small className="mb-0">🕐 Last Update: {lastUpdate}</small>
            </div>
          )}
        </div>
      </div>

      {/* HEADER */}
      <div className="card shadow-lg border-0 mb-4 rounded-4">
        <div className="card-body p-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h3 className="fw-bold text-primary mb-0">INR Option Chain</h3>
            {currentTokensRef.current.length > 0 && (
              <div className="badge bg-info fs-6 px-3 py-2">
                📊 Tracking {currentTokensRef.current.length} tokens
              </div>
            )}
          </div>

          {/* SEARCH & EXPIRY SECTION */}
          <div className="row g-3">
            {/* SYMBOL SEARCH */}
            <div className="col-md-6">
              <div className="position-relative" ref={dropdownRef}>
                <label className="fw-semibold mb-2">Search Symbol</label>
                <input
                  type="text"
                  className="form-control shadow-sm rounded-3"
                  placeholder="Type to search (e.g., NIFTY, BANKNIFTY)..."
                  value={symbolSearch}
                  onChange={(e) => {
                    setSymbolSearch(e.target.value);
                    handleSymbolSearch(e.target.value);
                  }}
                />

                {searchLoading && (
                  <div className="mt-1 small text-muted">
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </div>
                )}

                {searchResults.length > 0 && (
                  <ul
                    className="list-group position-absolute w-100 shadow border-0 mt-1"
                    style={{ zIndex: 10, maxHeight: "250px", overflowY: "auto" }}
                  >
                    {searchResults.map((item, index) => (
                      <li
                        key={index}
                        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const symbol = item.symbol;
                          setSymbolSearch(symbol);
                          setSearchResults([]);
                          handleExpirySelectInr(symbol);
                        }}
                      >
                        <span className="fw-semibold">{item.symbol}</span>
                        <i className="bi bi-arrow-right"></i>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            {/* EXPIRY DROPDOWN */}
            <div className="col-md-6">
              <label className="fw-semibold mb-2">Select Expiry Date</label>
              <select
                className="form-select shadow-sm rounded-3"
                value={selectedExpiry}
                onChange={(e) => {
                  const expiry = e.target.value;
                  setSelectedExpiry(expiry);
                  if (symbolSearch && expiry) {
                    handleshowalldatainr(symbolSearch, expiry);
                  }
                }}
                disabled={expiryListInr.length === 0}
              >
                <option value="">-- Select Expiry --</option>
                {expiryListInr.map((exp, i) => (
                  <option key={i} value={exp.expiry}>
                    {new Date(exp.expiryDate).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* LOADING */}
      {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status"></div>
          <p className="mt-3 fw-bold text-secondary fs-5">Loading option chain data...</p>
        </div>
      )}

      {/* INR OPTION TABLE */}
      {!loading && listDataInr.length > 0 && (
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-0">
            {/* FIXED HEADER */}
            <div className="table-responsive">
              <table className="table table-borderless text-center align-middle mb-0">
                <thead className="bg-primary text-white sticky-top">
                  <tr>
                    <th className="py-3" style={{ width: "40%" }}>CALL (CE)</th>
                    <th className="py-3" style={{ width: "20%" }}>STRIKE PRICE</th>
                    <th className="py-3" style={{ width: "40%" }}>PUT (PE)</th>
                  </tr>
                </thead>
              </table>
            </div>

            {/* SCROLLABLE BODY */}
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
              <table className="table table-hover text-center align-middle mb-0">
                <tbody>
                  {listDataInr.map((item, i) => (
                    <tr key={i} className="border-bottom">
                      {/* CALL (CE) */}
                      <td className="py-3" style={{ width: "40%" }}>
                        <div className="d-flex flex-column align-items-center">
                          <div
                            className="text-primary small mb-1 text-truncate"
                            style={{ fontSize: "9px", maxWidth: "200px" }}
                            title={item.call_tradesymbol}
                          >
                            {item.call_tradesymbol}
                          </div>
                          <div className="fw-bold fs-5 text-success mb-2">
                            ₹{Number(item.call_price || 0).toFixed(2)}
                          </div>
                          <div className="btn-group btn-group-sm">
                            <button
                              className="btn btn-success"
                              onClick={() =>
                                openOrderModal(
                                  item.call_tradesymbol,
                                  item.call_price || 0,
                                  "buy",
                                  "CE",
                                  item.strike_price,
                                  item.lotsize
                                )
                              }
                              disabled={!isLiveUpdating}
                            >
                              BUY
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={() =>
                                openOrderModal(
                                  item.call_tradesymbol,
                                  item.call_price || 0,
                                  "sell",
                                  "CE",
                                  item.strike_price,
                                  item.lotsize
                                )
                              }
                              disabled={!isLiveUpdating}
                            >
                              SELL
                            </button>
                          </div>
                        </div>
                      </td>

                      {/* STRIKE PRICE */}
                      <td className="py-3 fw-bold fs-4" style={{ width: "20%" }}>
                        ₹{item.strike_price}
                      </td>

                      {/* PUT (PE) */}
                      <td className="py-3" style={{ width: "40%" }}>
                        <div className="d-flex flex-column align-items-center">
                          <div
                            className="text-danger small mb-1 text-truncate"
                            style={{ fontSize: "9px", maxWidth: "200px" }}
                            title={item.put_tradesymbol}
                          >
                            {item.put_tradesymbol}
                          </div>
                          <div className="fw-bold fs-5 text-danger mb-2">
                            ₹{Number(item.put_price || 0).toFixed(2)}
                          </div>
                          <div className="btn-group btn-group-sm">
                            <button
                              className="btn btn-success"
                              onClick={() =>
                                openOrderModal(
                                  item.put_tradesymbol,
                                  item.put_price || 0,
                                  "buy",
                                  "PE",
                                  item.strike_price,
                                  item.lotsize
                                )
                              }
                              disabled={!isLiveUpdating}
                            >
                              BUY
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={() =>
                                openOrderModal(
                                  item.put_tradesymbol,
                                  item.put_price || 0,
                                  "sell",
                                  "PE",
                                  item.strike_price,
                                  item.lotsize
                                )
                              }
                              disabled={!isLiveUpdating}
                            >
                              SELL
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* NO DATA MESSAGE */}
      {!loading && symbolSearch && listDataInr.length === 0 && (
        <div className="alert alert-warning text-center mt-4">
          <i className="bi bi-info-circle me-2"></i>
          No option chain data available. Please select a symbol and expiry date.
        </div>
      )}

      {/* ORDER MODAL */}
      {showOrderModal && (
        <div
          className="modal show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
          onClick={() => !orderLoading && setShowOrderModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  {orderDetails.type.toUpperCase()} {orderDetails.optionType} @ Strike ₹
                  {orderDetails.strike}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowOrderModal(false)}
                  disabled={orderLoading}
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label fw-semibold">Symbol</label>
                  <input
                    type="text"
                    className="form-control"
                    value={orderDetails.symbol}
                    disabled
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Order Type</label>
                  <select
                    className="form-select"
                    value={orderDetails.selectedOption}
                    onChange={(e) =>
                      setOrderDetails({ ...orderDetails, selectedOption: e.target.value })
                    }
                  >
                    <option value="Market">Market</option>
                    <option value="Limit">Limit</option>
                    <option value="Stop">Stop</option>
                  </select>
                </div>

                {(orderDetails.selectedOption === "Limit" ||
                  orderDetails.selectedOption === "Stop") && (
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Limit/Stop Price</label>
                    <input
                      type="number"
                      className="form-control"
                      value={orderDetails.limitStopPrice || orderDetails.price}
                      onChange={(e) =>
                        setOrderDetails({
                          ...orderDetails,
                          limitStopPrice: e.target.value,
                        })
                      }
                      step="0.01"
                    />
                  </div>
                )}

                <div className="mb-3">
                  <label className="form-label fw-semibold">Current Price</label>
                  <input
                    type="number"
                    className="form-control"
                    value={orderDetails.price}
                    disabled
                  />
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-semibold">Lot</label>
                    <input
                      type="number"
                      className="form-control"
                      value={orderDetails.lot}
                      onChange={(e) =>
                        setOrderDetails({
                          ...orderDetails,
                          lot: parseInt(e.target.value) || 1,
                        })
                      }
                      min="1"
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-semibold">Quantity</label>
                    <input
                      type="number"
                      className="form-control"
                      value={orderDetails.qty}
                      onChange={(e) =>
                        setOrderDetails({
                          ...orderDetails,
                          qty: parseInt(e.target.value) || 1,
                        })
                      }
                      min="1"
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-semibold">Lot Size</label>
                    <input
                      type="number"
                      className="form-control"
                      value={orderDetails.lotsize}
                      onChange={(e) =>
                        setOrderDetails({
                          ...orderDetails,
                          lotsize: parseInt(e.target.value) || 1,
                        })
                      }
                      min="1"
                    />
                  </div>
                </div>

                <div className="alert alert-info mb-0">
                  <strong>Required Fund:</strong> ₹
                  {(orderDetails.price * orderDetails.qty * orderDetails.lot).toFixed(2)}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowOrderModal(false)}
                  disabled={orderLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`btn btn-${orderDetails.type === "buy" ? "success" : "danger"}`}
                  onClick={handlePlaceOrder}
                  disabled={orderLoading}
                >
                  {orderLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : (
                    `Confirm ${orderDetails.type.toUpperCase()}`
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default OptionChain1;